import { createActionGroup, props } from "@ngrx/store";
import { EcoLabel, EcoLabelCreateRequest, EcoLabelUpdateRequest, Unspsc, UnspscCreateRequest, UnspscUpdateRequest } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// CATALOG DATASETS ACTIONS
// CRUD actions for catalog reference datasets. Data loading uses global store.
// **************************************************************************

export const CatalogDatasetsActions = createActionGroup({
    source: "Contract Admin / Catalog Datasets",
    events: {
        // *** ECO LABELS ***
        "Create EcoLabel": props<{ request: EcoLabelCreateRequest }>(),
        "Create EcoLabel Success": props<{ ecoLabel: EcoLabel; toastKey: string }>(),
        "Create EcoLabel Failure": props<{ error: AppError; toastKey: string }>(),

        "Update EcoLabel": props<{ id: number; request: EcoLabelUpdateRequest }>(),
        "Update EcoLabel Success": props<{ ecoLabel: EcoLabel; toastKey: string }>(),
        "Update EcoLabel Failure": props<{ error: AppError; toastKey: string }>(),

        "Delete EcoLabel": props<{ id: number }>(),
        "Delete EcoLabel Success": props<{ id: number; toastKey: string }>(),
        "Delete EcoLabel Failure": props<{ error: AppError; toastKey: string }>(),

        "Upload EcoLabel Image": props<{ id: number; file: File }>(),
        "Upload EcoLabel Image Success": props<{ ecoLabel: EcoLabel; toastKey: string }>(),
        "Upload EcoLabel Image Failure": props<{ error: AppError; toastKey: string }>(),

        "Delete EcoLabel Image": props<{ id: number }>(),
        "Delete EcoLabel Image Success": props<{ ecoLabel: EcoLabel; toastKey: string }>(),
        "Delete EcoLabel Image Failure": props<{ error: AppError; toastKey: string }>(),

        // *** UNSPSC ***
        "Create Unspsc": props<{ request: UnspscCreateRequest }>(),
        "Create Unspsc Success": props<{ unspsc: Unspsc; toastKey: string }>(),
        "Create Unspsc Failure": props<{ error: AppError; toastKey: string }>(),

        "Update Unspsc": props<{ id: number; request: UnspscUpdateRequest }>(),
        "Update Unspsc Success": props<{ unspsc: Unspsc; toastKey: string }>(),
        "Update Unspsc Failure": props<{ error: AppError; toastKey: string }>(),

        "Delete Unspsc": props<{ id: number }>(),
        "Delete Unspsc Success": props<{ id: number; toastKey: string }>(),
        "Delete Unspsc Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
